var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { CardContent } from 'material-ui';
import { connect } from 'react-redux';
import { CustomCardHeader } from '../CustomCardHeader';
import Typography from 'material-ui/Typography';
import VolumeOff from 'material-ui-icons/VolumeOff';
import VolumeMute from 'material-ui-icons/VolumeMute';
import VolumeDown from 'material-ui-icons/VolumeDown';
import VolumeUp from 'material-ui-icons/VolumeUp';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
export var BUTTON_STYLE = {
    width: 48,
    minWidth: 48,
    height: 48,
    margin: 5,
};
var AudioComponent = /** @class */ (function (_super) {
    __extends(AudioComponent, _super);
    function AudioComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onPlaybackEnded = function () {
            _this.setState({ error: null, src: null });
        };
        _this.audio = document.createElement('audio');
        _this.audio.addEventListener('ended', _this.onPlaybackEnded);
        _this.state = _this.updatePlaying(props);
        return _this;
    }
    AudioComponent.prototype.componentWillReceiveProps = function (props) {
        if (this.props.audio !== props.audio) {
            this.setState(this.updatePlaying(props));
        }
    };
    AudioComponent.prototype.updatePlaying = function (props) {
        var _this = this;
        if (props.audio) {
            var src = URL.createObjectURL(new Blob([props.audio.audio]));
            if (this.audio.src) {
                URL.revokeObjectURL(this.audio.src);
            }
            this.audio.src = src;
            this.audio.currentTime = 0;
            this.audio.play().catch(function (e) {
                var error = e.message;
                _this.setState({ src: null, error: error });
            });
            return { error: null, src: src };
        }
        this.audio.currentTime = 0;
        this.audio.pause();
        return { error: null, src: null };
    };
    AudioComponent.prototype.render = function () {
        var _a = this.state, src = _a.src, error = _a.error;
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomCardHeader, null, "Audio"),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { style: BUTTON_STYLE, variant: "raised", disabled: true }, src ? React.createElement(AudioAnimation, null) : React.createElement(VolumeOff, null))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body1", style: { float: 'left', marginLeft: 2, paddingTop: 4 } }, src ? 'Playing...' : (error ? error : 'No audio playing')))))));
    };
    return AudioComponent;
}(React.PureComponent));
var AudioAnimation = /** @class */ (function (_super) {
    __extends(AudioAnimation, _super);
    function AudioAnimation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            anim: 0,
        };
        return _this;
    }
    AudioAnimation.prototype.componentWillMount = function () {
        var _this = this;
        this.intervalId = setInterval(function () {
            var anim = (_this.state.anim + 1) % 3;
            _this.setState({ anim: anim });
        }, 500);
    };
    AudioAnimation.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
    };
    AudioAnimation.prototype.render = function () {
        switch (this.state.anim) {
            case 0:
                return React.createElement("div", { style: { paddingRight: 4 } },
                    React.createElement(VolumeMute, null));
            case 1:
                return React.createElement("div", { style: { paddingLeft: 2, paddingRight: 2 } },
                    React.createElement(VolumeDown, null));
            default:
                return React.createElement("div", { style: { paddingLeft: 4 } },
                    React.createElement(VolumeUp, null));
        }
    };
    return AudioAnimation;
}(React.PureComponent));
export default connect(function (state) { return ({ audio: state.audio }); })(AudioComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/AudioComponent/index.tsx
// module id = 1773
// module chunks = 0